import { isSubscriptionAvailable, isSubscriptionForParticipantsAvailableAgain } from '../../utils';

let Menu
isSubscriptionAvailable() || isSubscriptionForParticipantsAvailableAgain() ?
  Menu = [
    {
      label: "Home",
      pathname: "/"
    },
    {
      label: "Programação",
      pathname: "/programacao"
    },
    {
      label: "Inscreva-se",
      pathname: "/inscreva-se"
    },
    {
      label: "Informações",
      pathname: "/mais"
    },
  ]
  :
  Menu = [
    {
      label: "Home",
      pathname: "/"
    },
    {
      label: "Programação",
      pathname: "/programacao"
    },
    {
      label: "Informações",
      pathname: "/mais"
    },
  ]

export default Menu